export function hasValue(value: any): boolean {
    return (value === 0 || (value != null && value !== '' && value !== undefined));
}
